var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 168,
    viewBox: "0 0 220 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 16C89.668 16.025 73.1915 32.5012 73.1666 52.8334V75.5C73.1666 77.0648 74.4352 78.3334 76 78.3334H87.3334C88.8982 78.3334 90.1668 77.0648 90.1668 75.5V52.8334C90.1666 41.8796 99.0464 33 110 33C120.954 33 129.833 41.8796 129.833 52.8334V75.5C129.833 77.0648 131.102 78.3334 132.667 78.3334H144C145.565 78.3334 146.833 77.0648 146.833 75.5V52.8334C146.808 32.5012 130.332 16.025 110 16Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72.6641H144C151.824 72.6641 158.167 79.0067 158.167 86.8306V137.831C158.167 145.655 151.824 151.997 144 151.997H76C68.176 151.997 61.8334 145.655 61.8334 137.831V86.8309C61.8334 79.0067 68.176 72.6641 76 72.6641Z",
    fill: "#FDBE44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.167 103.836C124.2 96.0119 117.884 89.6424 110.06 89.6095C102.236 89.5766 95.8664 95.8923 95.8334 103.716C95.8106 109.124 98.8687 114.074 103.716 116.472L101.528 131.772C101.309 133.322 102.387 134.755 103.937 134.975C104.068 134.993 104.201 135.002 104.333 135.002H115.667C117.231 135.018 118.513 133.763 118.528 132.198C118.53 132.054 118.52 131.909 118.5 131.767L116.312 116.467C121.1 114.071 124.136 109.189 124.167 103.836Z",
    fill: "#4D4D4D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-lock.5664eea38bfac7f3cce01a839f7ffbf7.svg";